import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startAt", "endAt", "allDay"]

  connect() {
    this.#applyAllDay()
  }

  toggleAllDay() {
    this.#applyAllDay()
  }

  syncEndAt() {
    if (this.endAtTarget.value) return
    if (!this.startAtTarget.value) return

    if (this.#allDay) {
      this.endAtTarget.value = this.startAtTarget.value
    } else {
      const date = new Date(this.startAtTarget.value)
      date.setHours(date.getHours() + 1)
      this.endAtTarget.value = this.#formatDatetimeLocal(date)
    }
  }

  get #allDay() {
    return this.hasAllDayTarget && this.allDayTarget.checked
  }

  // Swaps the start/end inputs between datetime-local and date-only,
  // preserving the date part of any value already entered.
  #applyAllDay() {
    const type = this.#allDay ? "date" : "datetime-local"

    ;[this.startAtTarget, this.endAtTarget].forEach(input => {
      if (input.type === type) return

      const value = input.value
      input.type = type
      if (value) input.value = this.#allDay ? value.slice(0, 10) : `${value.slice(0, 10)}T00:00`
    })
  }

  #formatDatetimeLocal(date) {
    const pad = n => String(n).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
      `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
}
